import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';
import type {
  GetCallbackUrlResponse,
  OAuthCallbackData,
  OauthCallbackConfigResponse,
  SetCallbackUrlPayload,
  SetOAuthCallbackResponse,
} from 'src/models';

export function getCallbackUrl() {
  return axios.request<GetCallbackUrlResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/channel/get-callback-config`,
  });
}

export function postSetCallbackUrl(data: SetCallbackUrlPayload) {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}/channel/set-callback-config`,
    data,
  });
}

export function getOauthCallbackConfig() {
  return axios.request<OauthCallbackConfigResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/channel/get-oauth-callback-config`,
  });
}

export function postSetOAuthCallbackConfig(data: OAuthCallbackData) {
  return axios.request<SetOAuthCallbackResponse>({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}/channel/set-oauth-callback-config`,
    data,
  });
}
